<div class="w-100 h-100 d-flex align-items-center justify-content-center">
  <mat-spinner></mat-spinner>
</div>